import {
  MatchRepository,
  ParticipantRepository,
  TournamentRepository
} from '../repositories';
import { GenerateBracketUseCase } from './GenerateBracketUseCase';
import { GenerateRoundRobinBracketUseCase } from './GenerateRoundRobinBracketUseCase';
import { GenerateSingleEliminationBracketUseCase } from './GenerateSingleEliminationBracketUseCase';
import { GenerateSwissBracketUseCase } from './GenerateSwissBracketUseCase';
import { GenerateTripleEliminationBracketUseCase } from './GenerateTripleEliminationBracketUseCase';
import { GenerateKingOfTheHillBracketUseCase } from './GenerateKingOfTheHillBracketUseCase';
import { logger } from '@/src/core/utils';

export class GenerateTournamentBracketUseCase {
  private generateDoubleEliminationUseCase: GenerateBracketUseCase;
  private generateSingleEliminationUseCase: GenerateSingleEliminationBracketUseCase;
  private generateRoundRobinUseCase: GenerateRoundRobinBracketUseCase;
  private generateSwissUseCase: GenerateSwissBracketUseCase;
  private generateTripleEliminationUseCase: GenerateTripleEliminationBracketUseCase;
  private generateKingOfTheHillUseCase: GenerateKingOfTheHillBracketUseCase;

  constructor(
    private tournamentRepository: TournamentRepository,
    participantRepository: ParticipantRepository,
    matchRepository: MatchRepository
  ) {
    this.generateDoubleEliminationUseCase = new GenerateBracketUseCase(
      tournamentRepository,
      participantRepository,
      matchRepository
    );
    this.generateSingleEliminationUseCase = new GenerateSingleEliminationBracketUseCase(
      tournamentRepository,
      participantRepository,
      matchRepository
    );
    this.generateRoundRobinUseCase = new GenerateRoundRobinBracketUseCase(
      tournamentRepository,
      participantRepository,
      matchRepository
    );
    this.generateSwissUseCase = new GenerateSwissBracketUseCase(
      tournamentRepository,
      participantRepository,
      matchRepository
    );
    this.generateTripleEliminationUseCase = new GenerateTripleEliminationBracketUseCase(
      tournamentRepository,
      participantRepository,
      matchRepository
    );
    this.generateKingOfTheHillUseCase = new GenerateKingOfTheHillBracketUseCase(
      tournamentRepository,
      participantRepository,
      matchRepository
    );
  }

  async execute(tournamentId: string): Promise<void> {
    const tournament = await this.tournamentRepository.getById(tournamentId);
    if (!tournament) {
      throw new Error('Tournament not found');
    }

    logger.debug('GenerateTournamentBracket', 'Generating bracket', { type: tournament.tournamentType });

    switch (tournament.tournamentType) {
      case 'double_elimination':
        await this.generateDoubleEliminationUseCase.execute(tournamentId);
        return;
      case 'single_elimination':
        await this.generateSingleEliminationUseCase.execute(tournamentId);
        return;
      case 'round_robin':
        await this.generateRoundRobinUseCase.execute(tournamentId);
        return;
      case 'swiss':
        await this.generateSwissUseCase.execute(tournamentId);
        return;
      case 'triple_elimination':
        await this.generateTripleEliminationUseCase.execute(tournamentId);
        return;
      case 'king_of_the_hill':
        await this.generateKingOfTheHillUseCase.execute(tournamentId);
        return;
      default:
        throw new Error(`Unknown tournament type: ${tournament.tournamentType}`);
    }
  }
}